import { render } from "./VoucherCarousel.vue?vue&type=template&id=4159e613&scoped=true"
import script from "./VoucherCarousel.vue?vue&type=script&lang=js"
export * from "./VoucherCarousel.vue?vue&type=script&lang=js"

import "./VoucherCarousel.vue?vue&type=style&index=0&id=4159e613&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4159e613"]])

export default __exports__